import type { AnalyticsAttributes } from '@atlassian/jira-product-analytics-bridge';
import { fireErrorAnalytics } from '@jira/platform__error-reporting/src/fireErrorAnalytics.tsx';

export const fireError = (
	messageOrError: string | Error,
	location: string,
	attributes?: AnalyticsAttributes,
): void => {
	const errorObject = messageOrError instanceof Error ? messageOrError : new Error(messageOrError);

	fireErrorAnalytics({
		error: errorObject,
		meta: {
			id: location,
			packageName: 'jiraAccessibleWorkflowDiagram',
			teamName: 'helix',
		},
		skipSentry: false,
		attributes,
	});
};
